import React from 'react';
import PropTypes from 'prop-types';
import Box from '../box';
import Click from '../click';
import Text from '../text';
var variants = {
  normal: {
    splash: {
      color: 'foreground.splash',
      bg: 'background.splash'
    },
    success: {
      color: 'foreground.successDark',
      bg: 'background.success'
    },
    info: {
      color: 'foreground.info',
      bg: 'background.info'
    },
    warning: {
      color: 'foreground.warningDark',
      bg: 'background.warning'
    },
    destructive: {
      color: 'foreground.destructiveDark',
      bg: 'background.destructive'
    }
  },
  prominent: {
    splash: {
      bg: 'eucalyptus400',
      color: 'white'
    },
    success: {
      bg: 'foreground.success',
      color: 'background.successDark'
    },
    info: {
      bg: 'cornflower500',
      color: 'white'
    },
    warning: {
      bg: 'foreground.warning',
      color: 'foreground.warningDark'
    },
    destructive: {
      bg: 'foreground.destructive',
      color: 'white'
    }
  }
};
var sizes = {
  small: {
    paddingHorizontal: 2,
    paddingVertical: 0.5,
    variant: 'birch'
  },
  medium: {
    paddingHorizontal: 2,
    paddingVertical: 1,
    variant: 'spruce'
  }
};
export default function Badge(_ref) {
  var children = _ref.children,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'normal' : _ref$intent,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'splash' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    action = _ref.action,
    target = _ref.target;
  var _ref2 = variants[intent][type] || {
      color: 'foreground.badge',
      bg: 'background.splash'
    },
    color = _ref2.color,
    bg = _ref2.bg;
  var _sizes$size = sizes[size],
    paddingHorizontal = _sizes$size.paddingHorizontal,
    paddingVertical = _sizes$size.paddingVertical,
    variant = _sizes$size.variant;
  var as = action ? Click : 'div';
  var href = typeof action === 'string' ? action : undefined;
  var onClick = typeof action === 'function' ? action : undefined;
  return /*#__PURE__*/React.createElement(Box, {
    as: as,
    onClick: onClick,
    href: href,
    target: target,
    width: "max-content",
    height: "max-content",
    bg: bg,
    paddingHorizontal: paddingHorizontal,
    paddingVertical: paddingVertical,
    extend: {
      // this is the only component with 4px radius right now
      // we might want to have consistent corners in the future
      // TODO: discuss with design
      borderRadius: 4,
      textDecoration: action ? 'underline' : undefined
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: color,
    variant: variant
  }, children));
}
Badge.propTypes = {
  children: PropTypes.node,
  intent: PropTypes.oneOf(['normal', 'prominent']),
  size: PropTypes.oneOf(['small', 'medium']),
  /** Either an onClick function or a href string */
  action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Allow to open in new window */
  target: PropTypes.oneOf(['_self', '_blank']),
  type: PropTypes.oneOf(['splash', 'success', 'warning', 'destructive', 'info'])
};